import usePass from './usePass';

/**
 * Hook to determine if the user has an active Plus pass
 * @returns {[boolean, import('../../../types/vansite').VanSite.Pass | null]} - The isPlusPass and annualPass.
 */
const usePassPlus = () => {
  const [isAnnualPassValid, annualPass] = usePass();

  if (!isAnnualPassValid || !annualPass) return [false, null];

  const isPlusPass = annualPass?.included?.plus === true;

  return [isPlusPass, isPlusPass ? annualPass : null];
};

export default usePassPlus;
